import React from "react";
import "./App.css";
import Header from "./header";
import { ThemeProvider } from "./ThemeContext";
import GetMemes from "./getMemes";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Edit from "./Edit";

function App() {
  return (
    <ThemeProvider>
      <Router>
        <div className="App">
          <Header />
          <Switch>
            <Route exact path="/" component={GetMemes} />
            <Route path="/edit/:id" component={Edit} />
          </Switch>
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
